import React, { useContext, useState } from "react";
import { AppContext } from "../../../../AppContext";
import "./LoginPanel.css";

const LoginPanel = ({ panelType = "Agent" }) => {
  const { setModal, setLoginModalInputs, setLoginModalAction, setUserType } =
    useContext(AppContext);

  const [visible, setVisible] = useState(panelType=="Agent"?"":"hidden");

  return (
    <div
      className="panel noActive disableHover"
      onClick={(e) => {
        if (e.target.id != "prioritizeClick") {
          visible === "hidden" ? setVisible("") : setVisible("hidden");
        }
      }}
    >
      <span className="Login-title">{panelType} Login</span>
      <div className={`Login-buttons ${visible}`}>
        <span
          className="button"
          id="prioritizeClick"
          onClick={() => {
            if (panelType === "Agent") {
              setUserType("Agent");
            } else if (panelType === "Loan Officer") {
              setUserType("Loan Officer");
            }
            setModal("active");
            setLoginModalInputs([
              ["userEmail", "Your Email:", "text"],
              ["userPassword", "Password:", "password"],
            ]);
            setLoginModalAction("getUserId");
          }}
        >
          Login
        </span>
        <div
          className="blueLink margin5Auto15 "
          id="prioritizeClick"
          onClick={(e) => {
            if (panelType === "Agent") {
              setUserType("Agent");
            } else if (panelType === "Loan Officer") {
              setUserType("Loan Officer");
            }
            setModal("active");
            setLoginModalInputs([["userEmail", "Your Email:", "text"]]);
            setLoginModalAction("resetPasswordTemporaryCode");
          }}
        >
          Reset Password
        </div>
        <span
          className="button"
          id="prioritizeClick"
          onClick={(e) => {
            if (panelType === "Agent") {
              setUserType("Agent");
            } else if (panelType === "Loan Officer") {
              setUserType("Loan Officer");
            }
            setModal("active");
            setLoginModalInputs([["userEmail", "Your Email:", "text"]]);
            setLoginModalAction("createAccount");
          }}
        >
          Create Account
        </span>
      </div>
    </div>
  );
};

export default LoginPanel;
